export default __webpack_public_path__ + "static/cost-874d650363f6aa32fddffdafbd82b74f.png";